<div class="mainAppContainer" appSetBackground>
  <app-background-overlay></app-background-overlay>
  @if (showHeader) {
    <app-header></app-header>
  }
  <router-outlet />
</div>
@if (showChatbotButton) {
  <div class="chatbotBtnContainer" (click)="toggleChatbot()">
    <img src="assets/chatbot_bg.png" class="chatbotBtnBg" draggable="false" />
    <ng-lottie class="chatbotBtnFg" [options]="options" (animationCreated)="animationCreated($event)" />
    <!-- <img src="assets/chatbot.png" class="chatbotBtnFg" draggable="false" /> -->
  </div>
}
@if (showChatbot) {
  <div class="chatbotContainer">
    <chatbotv2 [(shouldShow)]="showChatbot"></chatbotv2>
  </div>
}
